import React from "react";
import PublicHeader from "../common/PublicHeader";
import styles from "./About.module.css";

const About = (): React.JSX.Element => {
  return (
    <div className={styles["about-container"]}>
      <PublicHeader />
      <div className={styles["about-content"]}>
        <div className={styles["about-card"]}>
          <h1>About HallHero</h1>
          <p>
            HallHero is a free hall pass management system for schools, built by
            Ben Koch, a former teacher who spent a year and a half teaching in
            LBUSD and two years in LAUSD. Along the way, an interest in
            automation and improving clunky processes turned into HallHero — a
            tool built to help make sure students are actually spending their
            time in class, learning.
          </p>

          <h2>Your data, protected</h2>
          <ul>
            <li>
              HallHero acts solely as a <strong>custodian</strong> of the data
              your school provides — never as its owner.
            </li>
            <li>
              Student and staff data is{" "}
              <strong>never sold, rented, leased, or shared</strong> with third
              parties for any purpose.
            </li>
            <li>
              Data is <strong>never used to build advertising profiles</strong>{" "}
              or for any marketing purpose, targeted or otherwise.
            </li>
            <li>
              Data is used <strong>exclusively</strong> to operate the hall pass
              system for the benefit of your school.
            </li>
            <li>
              Your school can request full data deletion{" "}
              <strong>at any time, for any reason</strong>, and it will be
              completed within <strong>30 days</strong>.
            </li>
          </ul>

          <h2>Compliance</h2>
          <ul>
            <li>
              <strong>FERPA</strong>: HallHero operates under the "school
              official" exception — data is used only for the legitimate
              educational purpose your school directed, under your school's
              control.
            </li>
            <li>
              <strong>California SOPIPA</strong>: As a K-12 school service
              provider, HallHero does not sell student information, does not use
              it for targeted advertising, and does not build profiles of
              students except in furtherance of authorized school purposes.
            </li>
            <li>
              <strong>California AB 1584</strong> (Ed Code §49073.1): Your
              school/district retains ownership of all pupil records; HallHero
              will execute a data protection agreement with your district on
              request.
            </li>
            <li>
              <strong>COPPA note</strong>: HallHero is intended for
              school-directed use with students of any age, provisioned by
              school staff rather than by student self-signup — no
              direct-to-consumer data collection from children occurs.
            </li>
          </ul>

          <h2>Security</h2>
          <ul>
            <li>
              Hosted on <strong>Google Cloud Run</strong> with Google-managed
              TLS on every connection — all traffic is encrypted in transit.
            </li>
            <li>
              Secrets and credentials are stored in{" "}
              <strong>Google Secret Manager</strong>, never in code or plaintext
              config.
            </li>
            <li>
              Access is <strong>role- and school-scoped</strong>: staff can only
              see data for their own school, enforced at the middleware layer on
              every request.
            </li>
            <li>
              <strong>Rate limiting</strong> protects login and API endpoints
              from abuse.
            </li>
            <li>
              <strong>Audit logging</strong> records role changes and account
              deletions.
            </li>
            <li>
              Accounts are provisioned by school admins only — there is no
              public self-signup.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
